/* Premier Catering — product page v2 (31-10-2026): gallery + zoom, option pills / selects with
   availability, variant sync (id, price, availability, SKU, image, URL), qty stepper, AJAX add to
   basket, sticky buy bar (no price). The quote modal script lives in snippets/pcp-contact. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pp]');
  if (!root) return;
  var moneyFmt = root.getAttribute('data-money-format') || '£{{amount}}';
  var pack = parseInt(root.getAttribute('data-pack'), 10) || 0;
  var noun = root.getAttribute('data-noun') || 'piece';
  var form = document.getElementById('pcp-form');
  var qtyInput = root.querySelector('[data-pcp-qty-input]');
  var idInput = root.querySelector('[data-pcp-variant-id]');
  var amountEl = root.querySelector('[data-pcp-amount]');
  var errEl = root.querySelector('[data-pcp-error]');
  var toast = root.querySelector('[data-pcp-toast]');
  var toastTimer = null;
  function qs(s, c) { return (c || root).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function money(cents) {
    var n = (parseInt(cents, 10) || 0) / 100, p = n.toFixed(2).split('.'), w = p[0], o = '';
    while (w.length > 3) { o = ',' + w.slice(-3) + o; w = w.slice(0, -3); }
    var amt = w + o + '.' + p[1];
    var f = moneyFmt.split('{{amount}}').join(amt).split('{{amount_no_decimals}}').join(w + o).split('{{amount_with_comma_separator}}').join(amt.replace('.', ','));
    return f.split(' (Inc')[0];
  }

  /* gallery */
  var zoom = qs('[data-pp-zoom]');
  var mainImg = document.getElementById('pp-main-img');
  var thumbs = qsa('[data-pp-thumb]');
  var countEl = qs('[data-pp-count]');
  function showThumb(btn) {
    if (!mainImg || !btn) return;
    mainImg.src = btn.getAttribute('data-src');
    mainImg.srcset = btn.getAttribute('data-srcset');
    mainImg.alt = btn.getAttribute('data-alt') || '';
    thumbs.forEach(function (b, i) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on && countEl) countEl.textContent = i + 1;
    });
    if (zoom) zoom.classList.remove('is-zoomed');
  }
  thumbs.forEach(function (b, i) {
    b.addEventListener('click', function () { showThumb(b); });
    b.addEventListener('keydown', function (e) {
      var n = null;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = thumbs[i + 1] || thumbs[0];
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = thumbs[i - 1] || thumbs[thumbs.length - 1];
      if (n) { e.preventDefault(); n.focus(); showThumb(n); }
    });
  });
  if (zoom && mainImg) {
    zoom.addEventListener('click', function () {
      if (window.matchMedia('(max-width: 900px)').matches) {
        if (thumbs.length > 1) { var a = thumbs.indexOf(qs('.pp-thumb.is-active')); showThumb(thumbs[(a + 1) % thumbs.length]); }
        return;
      }
      zoom.classList.toggle('is-zoomed');
    });
    zoom.addEventListener('mousemove', function (e) {
      if (!zoom.classList.contains('is-zoomed')) return;
      var r = zoom.getBoundingClientRect();
      mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
    zoom.addEventListener('mouseleave', function () { zoom.classList.remove('is-zoomed'); });
  }

  /* variants */
  var variants = null;
  var vs = qs('[data-pp-variants]');
  if (vs) { try { variants = JSON.parse(vs.textContent); } catch (e) { variants = null; } }
  var nOpts = 0;
  qsa('[data-pp-opt]').forEach(function (el) { nOpts = Math.max(nOpts, parseInt(el.getAttribute('data-pp-opt'), 10) + 1); });
  function selected() {
    var out = [];
    for (var i = 0; i < nOpts; i++) {
      var els = qsa('[data-pp-opt="' + i + '"]'), val = null;
      els.forEach(function (el) { if (el.type === 'radio') { if (el.checked) val = el.value; } else { val = el.value; } });
      out.push(val);
    }
    return out;
  }
  function find(sel) {
    if (!variants) return null;
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < sel.length; j++) { if (variants[i].options[j] !== sel[j]) { ok = false; break; } }
      if (ok) return variants[i];
    }
    return null;
  }
  function markPills(sel) {
    qsa('.pp-pill input[data-pp-opt]').forEach(function (inp) {
      var i = parseInt(inp.getAttribute('data-pp-opt'), 10);
      var test = sel.slice(); test[i] = inp.value;
      var v = find(test);
      inp.closest('.pp-pill').classList.toggle('is-unavailable', !v || !v.available);
    });
  }
  function setAvail(ok) {
    var add = qs('[data-pcp-add]'), st = qs('[data-pp-sticky-add]'), av = qs('[data-pcp-avail]'), sa = qs('[data-pp-sticky-avail]'), dyn = qs('[data-pp-dynamic]');
    var txt = ok ? 'In stock - ready to ship' : 'Out of stock';
    if (add) { add.disabled = !ok; var l = add.querySelector('.pp-add__label'); if (l) l.textContent = ok ? 'Add to basket' : 'Out of stock'; }
    if (st) { st.disabled = !ok; st.textContent = ok ? 'Add to basket' : 'Out of stock'; }
    if (av) { av.classList.toggle('is-in', ok); av.classList.toggle('is-out', !ok); var t = av.querySelector('[data-pp-avail-text]'); if (t) t.textContent = txt; }
    if (sa) sa.textContent = txt;
    if (dyn) dyn.hidden = !ok;
  }
  function onChange() {
    var sel = selected();
    markPills(sel);
    var v = find(sel);
    if (!v) { setAvail(false); return; }
    if (idInput) idInput.value = v.id;
    if (amountEl) amountEl.textContent = money(v.price);
    setAvail(!!v.available);
    var sku = qs('[data-pp-sku]');
    if (sku) sku.textContent = v.sku || '—';
    if (v.featured_media && v.featured_media.id) {
      var t = qs('[data-pp-thumb][data-media-id="' + v.featured_media.id + '"]');
      if (t) showThumb(t);
      else if (mainImg && v.featured_image) { mainImg.src = v.featured_image.src; mainImg.removeAttribute('srcset'); }
    } else if (mainImg && v.featured_image && v.featured_image.src) { mainImg.src = v.featured_image.src; mainImg.removeAttribute('srcset'); }
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) {}
  }
  qsa('[data-pp-opt]').forEach(function (el) { el.addEventListener('change', onChange); });
  if (variants) markPills(selected());

  /* quantity */
  function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pp-qty]');
    if (b && qtyInput) { qtyInput.value = Math.max(1, qty() + parseInt(b.getAttribute('data-pp-qty'), 10)); if (errEl) errEl.hidden = true; }
  });
  if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); });

  /* add to basket */
  function showToast(text, isErr) {
    if (!toast) return;
    var t = toast.querySelector('[data-pcp-toast-text]'); if (t) t.textContent = text;
    toast.classList.toggle('is-error', !!isErr); toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }
  function addToCart() {
    var add = qs('[data-pcp-add]');
    if (!form || (add && (add.disabled || add.classList.contains('is-busy')))) return;
    if (add) { add.classList.add('is-busy'); add.setAttribute('aria-busy', 'true'); }
    if (qtyInput) qtyInput.value = qty();
    var q = qty();
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (add) { add.classList.remove('is-busy'); add.removeAttribute('aria-busy'); }
        if (!res.ok) {
          var m = res.body && res.body.description ? res.body.description : 'Could not add to basket — please try again';
          if (errEl) { errEl.textContent = m; errEl.hidden = false; }
          if (add) { add.classList.add('is-error'); setTimeout(function () { add.classList.remove('is-error'); }, 2500); }
          showToast(m, true); return;
        }
        if (add) { add.classList.add('is-done'); setTimeout(function () { add.classList.remove('is-done'); }, 2200); }
        showToast(pack > 1 ? q + (q === 1 ? ' pack' : ' packs') + ' (' + (q * pack) + ' ' + noun + (noun === 'glass' ? 'es' : 's') + ') added to basket' : (q > 1 ? q + ' added to basket' : 'Added to basket'));
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { source: 'pcp' } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'pcp' } }));
      })
      .catch(function () {
        if (add) { add.classList.remove('is-busy'); add.removeAttribute('aria-busy'); }
        showToast('Could not add to basket — please check your connection and try again', true);
      });
  }
  if (form) form.addEventListener('submit', function (e) {
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault(); addToCart();
  });
  var stAdd = qs('[data-pp-sticky-add]');
  if (stAdd) stAdd.addEventListener('click', addToCart);

  /* sticky bar: shown once the Add to basket button has scrolled above the viewport */
  var sticky = qs('[data-pp-sticky]'), addBtn = qs('[data-pcp-add]');
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.hidden = !show; sticky.classList.toggle('is-visible', show); document.body.classList.toggle('pp-has-sticky', show);
    }, { threshold: 0 }).observe(addBtn);
  }
})();
